import { Listener } from './Listener';
import { TrackingHandler } from '../TrackingHandler';
import { getScript } from '../../helpers/get-resource';
export class HotJarListener extends Listener {
    hotJarInitialized = false;
    pageReady(eventId) {
        if (!TrackingHandler.getInstance().consent.marketing) {
            return;
        }
        this.initializeHotJar();
    }
    setConsent(eventId, essential, functional, marketing) {
        if (!marketing) {
            return;
        }
        this.initializeHotJar();
    }
    initializeHotJar() {
        if (this.hotJarInitialized) {
            return;
        }
        this.hotJarInitialized = true;
        if (!window.siteSettings.hotJarId) {
            return;
        }
        if (TrackingHandler.getInstance().isInternalTest) {
            return;
        }
        window.hj = () => {
            (window.hj.q = window.hj.q || []).push(arguments);
        };
        window._hjSettings = { hjid: window.siteSettings.hotJarId, hjsv: 6 };
        getScript(`https://static.hotjar.com/c/hotjar-${window.siteSettings.hotJarId}.js?sv=6`, null);
    }
}
